import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { addClient } from '../../../actions';
import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';
import { TextField } from '../ui/FormField';

// Redesign of newadmin/AddClientModal.js — dispatches the same
// addClient({ name, email, mobile }) thunk.
const AddClientModal = ({ open, onClose }) => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');

    const reset = () => {
        setName('');
        setEmail('');
        setMobile('');
    };

    const close = () => {
        reset();
        onClose();
    };

    const formSubmit = (e) => {
        e.preventDefault();
        dispatch(addClient({ name, email, mobile }));
        close();
    };

    return (
        <Modal open={open} onClose={close} title="Add Client" size="lg">
            <form onSubmit={formSubmit} className="flex flex-col flex-1 min-h-0 overflow-hidden">
                <ModalBody className="flex-1">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <TextField
                            label="Client Name"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Client Name"
                        />
                        <TextField
                            label="Client Mobile"
                            required
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            placeholder="Client Mobile"
                        />
                        <TextField
                            label="Client Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Client Email"
                            className="sm:col-span-2"
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={close}>
                        Close
                    </Button>
                    <Button type="submit">Add Client</Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default AddClientModal;
